export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/ShapeParser.worker.aa7b9b20.worker.js");
}
